function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Iconly/Bulk/Calling"
}, /*#__PURE__*/React.createElement("g", {
  id: "Calling"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 1",
  d: "M17.548 14.2365C16.897 14.0975 16.382 14.3985 15.926 14.6605C15.459 14.9295 15.055 15.1635 14.547 14.9785C11.94 13.9155 10.079 12.0535 9.01902 9.45749C8.83202 8.94149 9.06502 8.53649 9.33402 8.06749C9.59602 7.61349 9.89302 7.09649 9.75802 6.44649C9.63502 5.86149 7.76102 3.50449 7.20302 2.95849C6.83502 2.59949 6.45802 2.40149 6.07202 2.36849C4.61702 2.30749 2.81802 4.40449 2.53202 4.86549C1.81802 5.84849 1.82302 7.15649 2.54502 8.74249C4.28402 13.0025 10.934 19.6535 15.242 21.4445C16.037 21.8145 16.764 21.9985 17.417 21.9985C18.057 21.9985 18.625 21.8215 19.114 21.4695C19.483 21.2595 21.678 19.3965 21.625 17.9135C21.593 17.5355 21.395 17.1575 21.036 16.7915C20.49 16.2325 18.133 14.3585 17.548 14.2365Z",
  fill: "#0041BE"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 4",
  opacity: 0.4,
  d: "M17.0598 9.78885C17.1288 10.1419 17.4358 10.3849 17.7818 10.3849C17.8288 10.3849 17.8758 10.3799 17.9238 10.3709C18.3228 10.2929 18.5828 9.90585 18.5048 9.50785C18.1068 7.46585 16.5298 5.88985 14.4888 5.49185C14.0918 5.42285 13.7038 5.67385 13.6248 6.07385C13.5478 6.47285 13.8088 6.85985 14.2068 6.93685C15.6578 7.21985 16.7768 8.33885 17.0598 9.78885Z",
  fill: "#0041BE"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 6",
  opacity: 0.4,
  d: "M14.4294 2.0057C14.0244 1.9547 13.6604 2.2517 13.6164 2.6557C13.5714 3.0607 13.8634 3.4237 14.2664 3.4687C17.5804 3.8367 20.1554 6.4077 20.5274 9.7227C20.5704 10.0977 20.8884 10.3757 21.2584 10.3757C21.2854 10.3757 21.3134 10.3737 21.3414 10.3707C21.7454 10.3257 22.0364 9.9617 21.9904 9.5577C21.5404 5.5557 18.4314 2.4497 14.4294 2.0057Z",
  fill: "#0041BE"
})));

function SvgCalling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/Calling.3bcf51cd.svg";
export { ForwardRef as ReactComponent };